/**
 * Catálogo de los campos de usuario que Provalia necesita en SAP Business One.
 *
 * Es la ÚNICA lista: de aquí sale el instalador del panel (que los crea en
 * `UserFieldsMD`), la comprobación de que un cliente los tiene todos y la
 * tabla del apartado 5.4 del documento funcional. Un campo que se añade en
 * otro sitio y no aquí existe en SAP sin que nadie sepa para qué.
 *
 * Todos se llaman `U_EDI_<Nombre>` (requisito de ECINSA). En `UserFieldsMD` se
 * dan de alta SIN el prefijo `U_`, que SAP añade solo: `name` es lo que se
 * manda y `field` es como se leen y escriben en los documentos.
 */
const ACCEPTANCE = [
    { value: 'P', description: 'Pendiente de aceptar' },
    { value: 'A', description: 'Aceptado' },
    { value: 'R', description: 'Rechazado' },
];
const VALIDATION = [
    { value: 'P', description: 'Pendiente' },
    { value: 'A', description: 'Automática (en tolerancia)' },
    { value: 'V', description: 'Pendiente de validar' },
    { value: 'C', description: 'Aprobada por compras' },
    { value: 'R', description: 'Rechazada por compras' },
];
const YES_NO = [
    { value: 'Y', description: 'Sí' },
    { value: 'N', description: 'No' },
];
function udf(def) {
    return { ...def, field: `U_${def.name}` };
}
export const UDF_CATALOG = [
    // ── Cabecera del pedido de compra ──────────────────────────────────────
    udf({ table: 'OPOR', name: 'EDI_EstAcept', type: 'alpha', size: 1, description: 'Provalia: estado de aceptación', validValues: ACCEPTANCE, defaultValue: 'P' }),
    udf({ table: 'OPOR', name: 'EDI_FecEnvio', type: 'date', description: 'Provalia: fecha de publicación al proveedor' }),
    udf({ table: 'OPOR', name: 'EDI_FecAcept', type: 'date', description: 'Provalia: fecha de aceptación o rechazo' }),
    udf({ table: 'OPOR', name: 'EDI_UsrAcept', type: 'alpha', size: 100, description: 'Provalia: usuario que acepta o rechaza' }),
    udf({ table: 'OPOR', name: 'EDI_MotRechazo', type: 'alpha', size: 254, description: 'Provalia: motivo del rechazo' }),
    // ── Líneas del pedido de compra ────────────────────────────────────────
    udf({ table: 'POR1', name: 'EDI_VerPlano', type: 'numeric', size: 6, description: 'Provalia: versión del plano a fabricar' }),
    udf({ table: 'POR1', name: 'EDI_FecReq', type: 'date', description: 'Provalia: fecha requerida original' }),
    udf({ table: 'POR1', name: 'EDI_FecProp', type: 'date', description: 'Provalia: fecha propuesta por el proveedor' }),
    udf({ table: 'POR1', name: 'EDI_EstFecha', type: 'alpha', size: 1, description: 'Provalia: estado de la fecha', validValues: VALIDATION, defaultValue: 'P' }),
    udf({ table: 'POR1', name: 'EDI_FecConf', type: 'date', description: 'Provalia: fecha de entrega comprometida' }),
    udf({ table: 'POR1', name: 'EDI_NumAlb', type: 'alpha', size: 50, description: 'Provalia: número de albarán del proveedor' }),
    udf({ table: 'POR1', name: 'EDI_PrecioAlb', type: 'price', description: 'Provalia: precio del albarán' }),
    udf({ table: 'POR1', name: 'EDI_PrecioOrig', type: 'price', description: 'Provalia: precio original del pedido' }),
    udf({ table: 'POR1', name: 'EDI_EstPrecio', type: 'alpha', size: 1, description: 'Provalia: estado de la validación de precio', validValues: VALIDATION, defaultValue: 'P' }),
    udf({ table: 'POR1', name: 'EDI_RecFisica', type: 'alpha', size: 1, description: 'Provalia: recepción física en playa', validValues: YES_NO, defaultValue: 'N' }),
    udf({ table: 'POR1', name: 'EDI_FecRecFis', type: 'date', description: 'Provalia: fecha de recepción física' }),
    udf({ table: 'POR1', name: 'EDI_UsrRecFis', type: 'alpha', size: 100, description: 'Provalia: usuario que confirma la recepción' }),
    udf({ table: 'POR1', name: 'EDI_LuzVerde', type: 'alpha', size: 1, description: 'Provalia: luz verde a la entrada', validValues: YES_NO, defaultValue: 'N' }),
    // ── Ficha del proveedor ────────────────────────────────────────────────
    udf({ table: 'OCRD', name: 'EDI_Eval', type: 'percentage', description: 'Provalia: puntuación global (%)' }),
    udf({ table: 'OCRD', name: 'EDI_EvCalidad', type: 'percentage', description: 'Provalia: calidad de piezas (%)' }),
    udf({ table: 'OCRD', name: 'EDI_EvPuntual', type: 'percentage', description: 'Provalia: puntualidad (%)' }),
    udf({ table: 'OCRD', name: 'EDI_EvDispon', type: 'percentage', description: 'Provalia: disponibilidad (%)' }),
    udf({ table: 'OCRD', name: 'EDI_EvAgilidad', type: 'percentage', description: 'Provalia: agilidad de gestión (%)' }),
    udf({ table: 'OCRD', name: 'EDI_EvalManual', type: 'alpha', size: 1, description: 'Provalia: valoración fijada al 100 %', validValues: YES_NO, defaultValue: 'N' }),
    udf({ table: 'OCRD', name: 'EDI_FecEval', type: 'date', description: 'Provalia: fecha del último cálculo' }),
];
/** Nombres de campo tal y como se leen en los documentos, para no teclearlos a mano. */
export const F = {
    acceptance: 'U_EDI_EstAcept',
    sentAt: 'U_EDI_FecEnvio',
    acceptedAt: 'U_EDI_FecAcept',
    acceptedBy: 'U_EDI_UsrAcept',
    rejectReason: 'U_EDI_MotRechazo',
    drawingVersion: 'U_EDI_VerPlano',
    requiredDate: 'U_EDI_FecReq',
    proposedDate: 'U_EDI_FecProp',
    dateStatus: 'U_EDI_EstFecha',
    confirmedDate: 'U_EDI_FecConf',
    deliveryNoteNumber: 'U_EDI_NumAlb',
    deliveryNotePrice: 'U_EDI_PrecioAlb',
    originalPrice: 'U_EDI_PrecioOrig',
    priceStatus: 'U_EDI_EstPrecio',
    physicalReceipt: 'U_EDI_RecFisica',
    physicalReceiptAt: 'U_EDI_FecRecFis',
    physicalReceiptBy: 'U_EDI_UsrRecFis',
    greenLight: 'U_EDI_LuzVerde',
    evaluation: 'U_EDI_Eval',
    evalQuality: 'U_EDI_EvCalidad',
    evalPunctuality: 'U_EDI_EvPuntual',
    evalAvailability: 'U_EDI_EvDispon',
    evalAgility: 'U_EDI_EvAgilidad',
    evalManual: 'U_EDI_EvalManual',
    evalDate: 'U_EDI_FecEval',
};
// Comprobación al cargar el módulo: un nombre de más de 18 caracteres lo
// rechaza SAP al crearlo, y el instalador fallaría a medias en un cliente real.
for (const def of UDF_CATALOG) {
    if (def.name.length > 18 || !def.name.startsWith('EDI_')) {
        throw new Error(`Campo de usuario mal definido en el catálogo: ${def.name}`);
    }
}
//# sourceMappingURL=udf.js.map